module.exports = __webpack_public_path__ + "static/media/alarm-clock.1b48ba60.svg";